export default __webpack_public_path__ + "static/media/yemi.9ed2355a.png";